export const APP_NAME = "sendr.fun";
export const DOMAIN = "sendr.fun";
export const SUPPORT_EMAIL = "support@sendr.fun";
export const NEW_ACCOUNT_TIER_LABEL = "Basic";
export const TOKEN_KEY = "sendr.token";
export const DRAFT_KEY = "sendr.draft";
export const API_BASE = "";
export const SESSION_POLL_INTERVAL = 30_000;
export const SEARCH_DEBOUNCE_MS = 300;
export const DRAFT_SAVE_DEBOUNCE_MS = 800;
export const DEFAULT_PAGE_SIZE = 200;
export const MAX_ATTACHMENT_SIZE = 25 * 1024 * 1024;
export const TURNSTILE_SITE_KEY = "0x4AAAAAADt66hus9GU8xNXY";
